import { useStorageGetBadgeTemplate } from '../../../../../ui/features/badge-management/hooks/useStorageGetBadgeTemplate';
import { CircularProgress } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';
export const BadgeCreatePage = ({ BadgeCreateComponent }) => {
    const { templateId } = useParams();
    const { data: badgeTemplate, isLoading } = useStorageGetBadgeTemplate(templateId);
    if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    return React.createElement(BadgeCreateComponent, { badgeTemplate: badgeTemplate });
};
